import { FC, ReactNode, createContext } from 'react';
import { IUseTennisApi, THEME_VARIANTS, Themes } from '../../../../packages/types';
import { ErrorBoundary } from 'react-error-boundary';
import FallbackError from '@velinsi/smp-widgets-ui/src/molecules/FallbackError/FallbackError';

const TennisApiContext = createContext<IUseTennisApi>({});

export default TennisApiContext;

type Properties = {
  value: IUseTennisApi;
  children: ReactNode;
  dataTheme?: Themes | null;
  themes?: { dark?: unknown; light?: unknown; client?: unknown };
};

export const TennisApiProvider: FC<Properties> = ({ value, children, themes, dataTheme }) => {
  return (
    <TennisApiContext.Provider value={value}>
      <ErrorBoundary fallback={<FallbackError themes={themes} dataTheme={dataTheme ?? THEME_VARIANTS.LIGHT} />}>{children}</ErrorBoundary>
    </TennisApiContext.Provider>
  );
};
